import { useState } from "react";
import { AiFillCaretDown } from "react-icons/ai";
import {
  FaAlignCenter,
  FaAngleLeft,
  FaAngleRight,
  FaArrowLeft,
  FaBold,
  FaCircleNotch,
  FaGripHorizontal,
  FaHeading,
  FaItalic,
  FaLink,
  FaListOl,
  FaListUl,
  FaRemoveFormat,
  FaStrikethrough,
  FaUnderline,
} from "react-icons/fa";
import { FiAlignCenter, FiAlignJustify, FiAlignLeft, FiAlignRight } from "react-icons/fi";
import parse from "html-react-parser";

import ButtonItem from "./components/ButtonItem";
import EditorPopup from "./components/EditorPopup";

const SigmaRichEditor = ({ setcontent, content, isSticky }) => {
  const [popupMenu, setpopupMenu] = useState("");

  // const [local, setlocal] = useState(content);
  const [page, setpage] = useState(0);

  // SUB STATES
  const [subLink, setsubLink] = useState("");
  const [subForeColor, setsubForeColor] = useState("");
  const [subBackColor, setsubBackColor] = useState("");

  // INTERNAL SELECTION MECHANISM
  const [selectedRange, setselectedRange] = useState(null);
  const [selected, setselected] = useState(false);
  const [pos, setPos] = useState({ top: 0, left: 0 });
  const [nodes, setNodes] = useState([]);
  // const containerRef = useRef();

  const handleOnInput = (e) => {
    setcontent(e);
    // console.log(content);
  };

  function calculateNodes(el, tagName) {
    // reset sub fields
    setsubLink("");

    tagName = tagName.toLowerCase();
    let arr = [];

    let _target = el.parentNode;

    if (_target.parentNode?.style["text-align"]) {
      arr.push(_target.parentNode.style["text-align"]?.toUpperCase());
    }

    if (el.parentElement.getAttribute("href")) {
      setsubLink(el.parentElement.getAttribute("href"));
    }

    let done = false;
    while (!done) {
      arr.push(_target.nodeName);
      _target = _target.parentNode;
      if (_target.nodeName.toLowerCase() === tagName) done = true;
    }
    console.log(arr);

    return arr;
  }

  function selection() {
    // let flag = 2;
    let sel = window.getSelection();

    if (sel.toString().length > 0) {
      let positions = sel.getRangeAt(0).getBoundingClientRect();
      setPos((prev) => ({
        ...prev,
        top: isSticky ? "20%" : positions.top,
        left: isSticky ? "50%" : positions.left,
      }));
      setNodes([...calculateNodes(sel.getRangeAt(0).startContainer, "div")]);
      return sel.toString();
    }
  }

  const styleHandler = (command, val) => {
    console.log(command, val);
    if (val) {
      document.execCommand(command, false, val);
    } else {
      document.execCommand(command, false, null);
    }
  };

  const selectDetection = (e) => {
    if (selection()) {
      setselectedRange(saveSelection());
      setselected(true);
    } else {
      setselected(false);
      setpopupMenu("");
    }
  };

  const preventDeselection = (e) => {
    e = e || window.event;
    e.preventDefault();
  };

  function saveSelection() {
    var sel = window.getSelection();
    if (sel.getRangeAt && sel.rangeCount) {
      return sel.getRangeAt(0);
    }
  }

  function restoreSelection(range) {
    if (range) {
      if (window.getSelection) {
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
      } else if (document.selection && range.select) {
        range.select();
      }
    }
  }

  const subLinkExit = () => {
    restoreSelection(selectedRange);
    styleHandler("createLink", subLink);
    setpopupMenu("");
    setsubLink("");
  };

  const subColorsExit = () => {
    restoreSelection(selectedRange);
    if (subForeColor.length > 0) {
      styleHandler("foreColor", subForeColor);
    }
    if (subBackColor.length > 0) {
      styleHandler("backColor", subBackColor);
    }
    setpopupMenu("");
    setsubForeColor("");
    setsubBackColor("");
  };

  return (
    <div className="relative">
      {(selected || isSticky) && (
        <>
          {/* BLOCKS */}
          <EditorPopup
            pos={pos}
            activeOn="TYPOGRAPHY"
            popupMenu={popupMenu}
            setpopupMenu={setpopupMenu}
            heading="Typography"
            nodes={nodes}
            styleHandler={styleHandler}
            onExit={() => setpopupMenu("")}
            onMouseDown={preventDeselection}
            items={[
              { command: "formatBlock", content: "DIV", node: "DIV", value: "div" },
              { command: "formatBlock", content: "P", node: "P", value: "p" },
              { command: "formatBlock", content: "H1", node: "H1", value: "h1" },
              { command: "formatBlock", content: "H2", node: "H2", value: "h2" },
              { command: "formatBlock", content: "H3", node: "H3", value: "h3" },
              { command: "formatBlock", content: "H4", node: "H4", value: "h4" },
              { command: "formatBlock", content: "H5", node: "H5", value: "h5" },
            ]}
          />

          {/* ALIGNMENT */}
          <EditorPopup
            pos={pos}
            activeOn="ALIGN"
            popupMenu={popupMenu}
            setpopupMenu={setpopupMenu}
            heading="Alignments"
            nodes={nodes}
            styleHandler={styleHandler}
            onExit={() => setpopupMenu("")}
            onMouseDown={preventDeselection}
            items={[
              { command: "justifyLeft", content: <FiAlignLeft />, node: "LEFT", value: null },
              { command: "justifyCenter", content: <FiAlignCenter />, node: "CENTER", value: null },
              { command: "justifyRight", content: <FiAlignRight />, node: "RIGHT", value: null },
              { command: "justifyFull", content: <FiAlignJustify />, node: "JUSTIFY", value: null },
            ]}
          />

          {/* LINK */}
          <EditorPopup
            pos={pos}
            activeOn="LINK"
            popupMenu={popupMenu}
            setpopupMenu={setpopupMenu}
            heading="Add Link"
            styleHandler={styleHandler}
            onExit={subLinkExit}
            onMouseDown={preventDeselection}
          >
            <div>
              <input
                className="w-full focus:outline-none border border-solid border-slate-500 rounded text-xs px-2 py-1"
                onChange={(e) => setsubLink(e.target.value)}
                value={subLink}
              />
            </div>
          </EditorPopup>

          {/* COLORS */}
          <EditorPopup
            pos={pos}
            activeOn="COLORS"
            popupMenu={popupMenu}
            setpopupMenu={setpopupMenu}
            heading="Manage Colors"
            styleHandler={styleHandler}
            onExit={subColorsExit}
            onMouseDown={preventDeselection}
          >
            <>
              <div className="mb-2">
                <label>color</label>
                <input
                  className="w-full focus:outline-none rounded text-xs px-2 py-1"
                  onChange={(e) => setsubForeColor(e.target.value)}
                  value={subForeColor}
                  type="color"
                />
              </div>
              <div className="mb-2">
                <label>Back Color</label>
                <input
                  className="w-full focus:outline-none rounded text-xs px-2 py-1"
                  onChange={(e) => setsubBackColor(e.target.value)}
                  value={subBackColor}
                  type="color"
                />
              </div>
            </>
          </EditorPopup>

          <div
            style={{
              top: isSticky ? "-20px" : popupMenu.length === 0 ? pos.top - 30 : pos.top,
              left: isSticky ? "50%" : pos.left < 100 ? 120 : pos.left + 20,
            }}
            className={`${
              isSticky ? "absolute w-full bg-zinc-800" : "fixed bg-zinc-900"
            } -translate-x-1/2 -translate-y-1/2 text-white rounded flex items-center z-[200] fixed transform transition-all ${
              popupMenu.length === 0
                ? " opacity-100 visible pointer-events-auto"
                : "opacity-0 invisible pointer-events-none"
            }`}
          >
            {!isSticky && (
              <AiFillCaretDown
                size={18}
                className="absolute -bottom-5 text-zinc-900 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
              />
            )}

            {/* selector popup */}

            <div className="relative w-64 h-9">
              {/* PAGE 0 */}
              <div
                className={`${
                  page === 0
                    ? "top-0 opacity-100 visible pointer-events-auto"
                    : "-top-5 opacity-0 invisible pointer-events-none"
                } transition-all flex items-center absolute px-4 py-3 `}
              >
                <button
                  onClick={() => {
                    setpopupMenu("TYPOGRAPHY");
                  }}
                  className={`mx-2 text-xs`}
                >
                  <FaHeading />
                </button>

                <button
                  onClick={() => {
                    setpopupMenu("COLORS");
                  }}
                  className={`mx-2 text-xs`}
                >
                  <FaCircleNotch />
                </button>

                <ButtonItem
                  nodes={nodes}
                  Icon={FaBold}
                  command="bold"
                  node="B"
                  styleHandler={styleHandler}
                />
                <ButtonItem
                  nodes={nodes}
                  Icon={FaItalic}
                  command="italic"
                  node="I"
                  styleHandler={styleHandler}
                />
                <ButtonItem
                  nodes={nodes}
                  Icon={FaUnderline}
                  command="underline"
                  node="U"
                  styleHandler={styleHandler}
                />

                <button
                  onClick={() => {
                    setpopupMenu("ALIGN");
                  }}
                  className={`mx-2 text-xs `}
                >
                  <FaAlignCenter />
                </button>
                <button
                  onClick={() => setpopupMenu("LINK")}
                  className={`mx-2 text-xs ${nodes.includes("A") ? "text-sky-500" : "text-white"}`}
                >
                  <FaLink />
                </button>

                {/* To Page 2 button */}
                <button
                  onClick={() => setpage(1)}
                  className={`mx-2 text-xs ${nodes.includes("A") ? "text-sky-500" : "text-white"}`}
                >
                  <FaGripHorizontal />
                </button>
              </div>

              {/* PAGE 1 */}
              <div
                className={`${
                  page === 1
                    ? "top-0 opacity-100 visible pointer-events-auto"
                    : "top-5 opacity-0 invisible pointer-events-none"
                } transition-all flex items-center justify-between w-full absolute px-4 py-3`}
              >
                <ButtonItem
                  nodes={nodes}
                  Icon={FaStrikethrough}
                  command="strikethrough"
                  node="STRIKE"
                  styleHandler={styleHandler}
                />
                <ButtonItem
                  nodes={nodes}
                  Icon={FaListOl}
                  command="insertorderedlist"
                  node="OL"
                  styleHandler={styleHandler}
                />
                <ButtonItem
                  nodes={nodes}
                  Icon={FaListUl}
                  command="insertunorderedlist"
                  node="UL"
                  styleHandler={styleHandler}
                />
                <ButtonItem
                  nodes={nodes}
                  Icon={FaAngleRight}
                  command="SPAN"
                  node="LI"
                  styleHandler={styleHandler}
                />
                <ButtonItem
                  nodes={nodes}
                  Icon={FaAngleLeft}
                  command="outdent"
                  node=""
                  styleHandler={styleHandler}
                />
                <ButtonItem
                  nodes={nodes}
                  Icon={FaRemoveFormat}
                  command="removeformat"
                  node=""
                  styleHandler={styleHandler}
                />

                {/* To Page 0 button */}
                <button onClick={() => setpage(0)} className={`mx-2 text-xs `}>
                  <FaArrowLeft />
                </button>
              </div>
            </div>
          </div>
        </>
      )}
      <div
        id="content"
        // ref={containerRef}
        onMouseOut={selectDetection}
        onMouseUp={selectDetection}
        onKeyUp={selectDetection}
        className="min-h-[50px] bg-white border-none focus:border-none focus:outline-none unset-tailwind"
        contentEditable
        suppressContentEditableWarning={true}
        onInput={(e) => handleOnInput(e.currentTarget.innerHTML)}
        dangerouslySetInnerHTML={{ __html: content }}
      >
        {/* {content} */}
      </div>
    </div>
  );
};

export default SigmaRichEditor;
